import fm from 'format-message';

/**
 * Accessible name for links to a product color/variant.
 * @param productTitle — base product name
 * @param colorName — localized color label
 */
export function productVariantLinkAccessibleName(productTitle: string, colorName: string): string {
    const title = (productTitle || '').trim();
    const color = (colorName || '').trim();

    if (title && color) {
        return fm('{productTitle}, color {colorName}', { productTitle: title, colorName: color });
    }
    if (color) {
        return fm('Color {colorName}', { colorName: color });
    }
    if (title) {
        return title;
    }
    return fm('Product color option');
}
